import Swiper from "swiper";
import { Navigation, Autoplay, A11y } from "swiper/modules";

export default {
    name: 'slider',
    component() {
        return {
            initSlider() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    breakpoints: {
                        480: {
                            slidesPerView: 2,
                            spaceBetween: 10,
                        },
                        750: {
                            slidesPerView: 3,
                            spaceBetween: 15,
                        },
                        1000: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                    },
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderProduct() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },

            initSliderProductMedia() {
                const slider = this.$root.querySelector(".swiper");
                new Swiper(slider, {
                    modules: [Autoplay, A11y, Navigation],
                    direction: "horizontal",
                    loop: true,
                    slidesPerView: 1,
                    allowTouchMove: true,
                    disableOnInteraction: false,
                    spaceBetween: 10,
                    navigation: {
                        nextEl: this.$root
                            .querySelector("[data-slider-btn-next]"),
                        prevEl: this.$root
                            .querySelector("[data-slider-btn-prev]"),
                    },
                });
            },
        }
    }
}